import ConnectionServerIcon from "@nokia-csf-uxr/ccfk-assets/legacy/ConnectionServerIcon";
import ESimIcon from "@nokia-csf-uxr/ccfk-assets/legacy/ESimIcon";
import LanguageIcon from "@nokia-csf-uxr/ccfk-assets/legacy/LanguageIcon";
import ModemIcon from "@nokia-csf-uxr/ccfk-assets/legacy/ModemIcon";

import countryListData from "dot/Constants/countryList.json";
import currency from "dot/Constants/currency.json";


import AirportIcon from '@nokia-csf-uxr/ccfk-assets/legacy/AirportIcon';
import DefenceIcon from '@nokia-csf-uxr/ccfk-assets/legacy/DefenceIcon';
import IndustrialSiteIcon from '@nokia-csf-uxr/ccfk-assets/legacy/IndustrialSiteIcon';
import LogisticsIcon from '@nokia-csf-uxr/ccfk-assets/legacy/LogisticsIcon';
import ManufacturingIcon from '@nokia-csf-uxr/ccfk-assets/legacy/ManufacturingIcon';
import MiningIcon from '@nokia-csf-uxr/ccfk-assets/legacy/MiningIcon';
import OilAndGasIcon from '@nokia-csf-uxr/ccfk-assets/legacy/OilAndGasIcon';
import OtherIcon from '@nokia-csf-uxr/ccfk-assets/legacy/OtherIcon';
import PlantIcon from '@nokia-csf-uxr/ccfk-assets/legacy/PlantIcon'; //ENERGY
import PortIcon from '@nokia-csf-uxr/ccfk-assets/legacy/PortIcon';
import RailwayIcon from '@nokia-csf-uxr/ccfk-assets/legacy/RailwayIcon';
import SmartCityIcon from '@nokia-csf-uxr/ccfk-assets/legacy/SmartCityIcon';

// const CryptoJS = require("crypto-js");
export const ROLE = {
  ADMIN: "admin",
  INTERNAL: "internal",
  PARTNER: "partner",
};
export const caseTypesMap = {
  new: "New",
  addition_to_existing_edge: "Addition to existing Network",
  non_commercial_network: "Non-commercial Network",
  internal_order: "Internal Order",
  demand_forecast: "Demand forecast",
  frame_agreement: "Frame agreement / Commitments",
};

export const caseTypesMapPartner = {
  new: "New",
  addition_to_existing_edge: "Addition to existing Network",
  non_commercial_network: "Non-commercial Network",
};

export const debounceInterval = 1000;
export const customerInfoRegex = RegExp(/^\d{2}\.[a-zA-Z]{2}\.[a-zA-Z0-9]{6}$/);

export const toolRedirect = {
  OOT: {
    id: "OOT",
    urlPrefix:
      process.env.REACT_APP_OOT + "/ndac-login?destination=/offer/edit/",
    homePage: process.env.REACT_APP_OOT + "/offer/node/add/offers",
  },
  ENSO: {
    id: "ENSO",
    // urlPrefix: process.env.REACT_APP_ENSO + "/",
    domain: process.env.REACT_APP_ENSO,
    homePage:
      process.env.REACT_APP_ENSO +
      "/web#action=283&cids=1&id=&menu_id=174&model=sale.order&view_type=form",
    homePagePartner:
      process.env.REACT_APP_ENSO +
      "/web#action=283&cids=1&id=&menu_id=174&model=sale.order&view_type=form",
    urlPrefix: process.env.REACT_APP_ENSO + "/get_so_page/",
    urlPrefixPartner:
      process.env.REACT_APP_ENSO_PARTNER + "/get_partner_so_page/",
    dbName: process.env.REACT_APP_EOT_DB_NAME,
    clientID: process.env.REACT_APP_EOT_CLIENT_ID,
    tenantID: process.env.REACT_APP_EOT_TENANT_ID
  },
};

export const salesChannel = [
  {
    id: "DIR",
    value: "Direct [DIR]",
  },
  {
    id: "RES",
    value: "Reseller (or spectrum partner)  [RES]",
  },
  {
    id: "DIS",
    value: "Distributor [DIS]",
  },
];
export const market = [
  {
    id: "Global Frame",
    value: "Global Frame Agreement [Global Frame]",
  },
  {
    id: "APJ",
    value: "Asia Pacific & Japan [APJ]",
  },
  {
    id: "EUR",
    value: "Europe [EUR]",
  },
  {
    id: "GCHN",
    value: "Greater China [GCHN]",
  },
  {
    id: "INDIA",
    value: "India [INDIA]",
  },
  {
    id: "LAT",
    value: "Latin America [LAT]",
  },
  {
    id: "MEA",
    value: "Middle East & Africa [MEA]",
  },
  {
    id: "NAM",
    value: "North America [NAM]",
  },
];

export const networkids = [];

export const leadProduct = {
  NDAC: "Nokia Digital Automation Cloud (NDAC)",
  NDAC_explorer: " Nokia Digital Automation Cloud explorer ",
  NDAC_CAPEX: "Nokia Digital Automation Cloud CAPEX",
  HAIP: "High Accuracy Indoor Positioning (HAIP)",
  NDN: "Nokia Drone Networks (NDN)",
  DEV: "Devices",
};
export const extensionOfferTools = {
  MPW_GSM:
    "(MPW-S) Modular with choice of elements; customer owned and operated",
  NDAC: "(NDAC) Packaged Plug & Play as-a-service solution",
};

export const IndustrySegments = {
  AIR: "Airport",
  PORT: "Port Terminal",
  ENRGY: "Energy",
  INDUS: "Industrial",
  DEF: "Defense",
  THTR: "Theatre",
  INST: "Institutions",
  COMM: "Commercial",
  RAIL: "Railway",
  //OTHER: "Others",
  Referencesolution: "Reference Solution",
}; //outdated

export const portPlanSolutions = [
  { icon: ModemIcon, label: "AP", value: "Access points" },
  {
    icon: ConnectionServerIcon,
    label: "NDAC",
    value: "NDAC Egde: Large(includes 50 SIMs)",
  },
  {
    icon: LanguageIcon,
    label: "GEOR",
    value: "Geo Redundancy configuration for Large Enterprise",
  },
  { icon: ESimIcon, label: "SIM", value: "SIM card kit (25 SIM pack)" },
];

export const STATUS = {
  ERROR: "error",
  IDLE: "idle",
  LOADING: "loading",
  HIDE: "hide",
};

export const managePortTabTheme = {
  CONFIG: "Configuration",
  SERVICES: "Services",
  DISC: "Discount",
};

export const contractPlans = {
  BASIC: {
    name: "Basic",
    price: "1000",
    currency: "$",
    serivceDesk: "24/7",
    initRespTime: ["24h"],
    serviceReq: "24h",
    resolution: ["Best effort"],
    permanentFix: null,
    supportChannels: ["DAC info Center", "DAC Manager", "eMail"],
  },
  PROFESSIONAL: {
    name: "Professional",
    price: "1500",
    currency: "$",
    serivceDesk: "24/7",
    initRespTime: ["4h", "8h", "24h"],
    serviceReq: "48h",
    resolution: ["Best effort"],
    permanentFix: null,
    supportChannels: ["DAC info Center", "DAC Manager", "eMail"],
  },
  PREMIUM: {
    name: "Premium",
    price: "1700",
    currency: "$",
    serivceDesk: "24/7",
    initRespTime: ["4h", "8h", "12h"],
    serviceReq: "48h",
    resolution: ["P1 4h", "P2 8h", "P3 48h"],
    permanentFix: "30 days a month",
    supportChannels: [
      "DAC info Center",
      "DAC Manager",
      "eMail",
      "chat",
      "Escalation process",
    ],
  },
};

export const OOT_GLOBAL = {
  proxyUrl: process.env.REACT_APP_NODE,
  baseUrl: process.env.REACT_APP_OOT,
  endPoints: {
    login: "/api/v1/auth/token",
    getOffer: "/api/get-offer",
    getProducts: "/api/get-products",
    syncOffer: "/api/sync-offer",
    getOpportunity: "/api/get-opportunity-data",
    getAccountCustomer: "/api/account-data",
    getCustomer: "/api/customer-data",
    getCountryBands: "/api/get-country-bands",
    getApplicationTab: "/api/get-applicationTab",
    getConnectivitytab: "/api/get-connectivityTab",
    getEdgeTab: "/api/get-edgeTab",
    getDevicesTab: "/api/get-deviceTab",
    getServicesTab: "/api/get-servicesTab",
    // getProfessionalServicesTab:"/api/professional-service-data",
    getWarrantyTab: "/api/get-sla_warranty",

  }
};

// New changed subtype names for new casetype
export const caseSubTypes = {
  new: [
    {
      types: [
        { key: "dacot",type:"group", value: "DAC offer tool" }
      ],
      redirect: null,
    },
    {
      types: [
        // { key: "help", value: "Standard guided buying",icon:true }
        { key: "help", value: "Standard guided buying (MPW & NDAC)",icon:true }
      ],
      redirect: null,
    },
    {
      types: [
        { key: "dacadditionalsolution",type:"group", value: "Additional solution (To be deprecated)" }
      ],
      redirect: null,
    },
    {
      types: [
        {
          key: "pkg_plug_play",
          // value: "(NDAC) Packaged Plug & Play as-a-service solution > OOT",
          value: "OOT > (NDAC) Packaged plug & play solution",
          icon:true
        },
      ],
      redirect: toolRedirect.OOT,
    },
    {
      types: [
        // { key: "devices_only", value: "Devices only > OOT",icon:true },
        { key: "devices_only", value: "OOT > Devices only ",icon:true },
        // { key: "perimeter_nw", value: "Perimeter network > OOT",icon:true }
        { key: "perimeter_nw", value: "OOT > Perimeter network ",icon:true }
      ],
      redirect: toolRedirect.OOT,
    },
    {
      types: [
        {
          key: "modular",
          // value: "(MPW) Modular choice of elements > EOT",
          value: "EOT > (MPW) Modular private wireless",
          icon:true
        },
      ],
      redirect: toolRedirect.ENSO,
    },    
  ],
  addition_to_existing_edge: [
    {
      types: [{ key: "subscriptions_renewal", value: "Subscriptions renewal" }],
      redirect: toolRedirect.OOT,
    },
    {
      types: [
        {
          key: "extension_commercial_network",
          value: "Extension to existing commercial network",
        },
        { key: "sw_small_item_upsell", value: "SW and small items upsell" },
        { key: "free_of_charge", value: "Free of charge replacement" },
      ],
      redirect: null,
    },
  ],
  non_commercial_network: [
    {
      types: [
        // { key: "poc_saas", value: "PoC aaS" },
        { key: "subscriptions_renewal", value: "Subscriptions renewal" },
      ],
      redirect: toolRedirect.OOT,
    },
    {
      types: [
        { key: "new_proof_of_concept", value: "New Proof of Concept" },
        { key: "new_partner_demo_kit", value: "New Partner Demo Kit" },
        { key: "new_partner_lab", value: "New Partner Lab" },
        { key: "extension_to_existing", value: "Extension To Existing" },
      ],
      redirect: null,
    },
  ],
  internal_order: [
    {
      types: [
        { key: "new_network", value: "New network" },
        { key: "extension_to_existing", value: "Extension to existing" },
        { key: "sw_small_item_addition", value: "SW and small items addition" },
        { key: "subscriptions_renewal", value: "Subscriptions renewal" },
      ],
      redirect: null,
    },
  ],
  demand_forecast: [{ types: [], redirect: toolRedirect.OOT }],
  frame_agreement: [{ types: [
    {
      key : "_none", value : "--None--"
    },
    {
      key : "merchant_offer" , value:"Merchant/Marketplace Agreement"
    }
  ], redirect: toolRedirect.OOT }],
};


export const subtypes = [{ id: "help", value: "Help me identify solution type" }, {
  id: "extension_commercial_network",
  value: "Extension to existing commercial network",
},
{ id: "sw_small_item_upsell", value: "SW and small items upsell" },
{ id: "free_of_charge", value: "Free of charge replacement" },
// { id: "poc_saas", value: "PoC aaS" },
{ id: "subscriptions_renewal", value: "Subscriptions renewal" },
{ id: "new_proof_of_concept", value: "New Proof of Concept" },
{ id: "new_partner_demo_kit", value: "New Partner Demo Kit" },
{ id: "new_partner_lab", value: "New Partner Lab" },
{ id: "extension_to_existing", value: "Extension To Existing" },
{ id: "new_network", value: "New network" },
{ id: "extension_to_existing", value: "Extension to existing" },
{ id: "sw_small_item_addition", value: "SW and small items addition" },
{ id: "subscriptions_renewal", value: "Subscriptions renewal" },
{ id: "devices_only", value: "Devices only" },
{ id: "perimeter_nw", value: "Perimeter Network" },];
export const segmentSolution = [
  {
    id: "airport",
    name: "Airports",
    description: "Airport Segment",
    thumbnail: "/assets/images/segments/Airport.svg",
    svg: "/assets/segments_icons/ece_airport.svg",
    icon: AirportIcon,
  },
  {
    id: "rail",
    name: "Railways",
    description: "Railway Segment",
    thumbnail: "/assets/images/segments/Railways.svg",
    svg: "/assets/segments_icons/ece_railway.svg",
    icon: RailwayIcon,
  },
  {
    id: "port",
    name: "Ports",
    description: "Port Segment",
    thumbnail: "/assets/images/segments/Port.svg",
    svg: "/assets/segments_icons/ece_port.svg",
    icon: PortIcon
  },
  {
    id: "energy",
    name: "Energy",
    description: "Utility sites Power plants & renewable, sub-stations Segment",
    thumbnail: "/assets/images/segments/Utility_sites_renewables.svg",
    svg: "/assets/segments_icons/ece_utility_sites.svg",
    icon: PlantIcon
  },
  {
    id: "industrial",
    name: "Industrial",
    description: "Industrial sites, plants and campuses Segment",
    thumbnail: "/assets/images/segments/Industrial_sites.svg",
    svg: "/assets/segments_icons/ece_industrial-site.svg",
    icon: IndustrialSiteIcon,
  },
  // {
  //   id: "fan_regional",
  //   name: "Fan & regional",
  //   description: "Fan & regional Segment",
  //   thumbnail: "/assets/images/segments/Fan_regional.svg",
  // },
  // {
  //   id: "utility",
  //   name: "Utility FAN",
  //   description: "Utility FAN Segment",
  //   thumbnail: "/assets/images/segments/Utility_FAN.svg",
  // },
  {
    id: "smart_city",
    name: "Smart City",
    description: "Smart City Segment",
    thumbnail: "/assets/images/segments/Smart_city.svg",
    svg: "/assets/segments_icons/ece_smart_city.svg",
    icon: SmartCityIcon,
  },
  {
    id: "manufacturing",
    name: "Manufacturing",
    description: "Manufacturing Segment",
    thumbnail: "/assets/images/segments/Manufacturing.svg",
    svg: "/assets/segments_icons/ece_manufacturing.svg",
    icon: ManufacturingIcon,
  },
  {
    id: "logistics",
    name: "Logistics",
    description: "Logistics Segment",
    thumbnail: "/assets/images/segments/Logistics.svg",
    svg: "/assets/segments_icons/ece_logistic.svg",
    icon: LogisticsIcon,
  },
  {
    id: "mining",
    name: "Mining",
    description: "Mining Segment",
    thumbnail: "/assets/images/segments/Mining.svg",
    svg: "/assets/segments_icons/ece_mining.svg",
    icon: MiningIcon,
  },
  {
    id: "oil",
    name: "Oil & Gas",
    description: "Oil & Gas Segment",
    thumbnail: "/assets/images/segments/Oil_gas.svg",
    svg: "/assets/segments_icons/ece_oil_and_gas.svg",
    icon: OilAndGasIcon,
  },
  {
    id: "defence",
    name: "Defence",
    description: "Defence Segment",
    thumbnail: "/assets/images/segments/Defence.svg",
    svg: "/assets/segments_icons/ece_defence.svg",
    icon: DefenceIcon,
  },
  // {
  //   id: "others",
  //   name: "Others",
  //   description: "Others",
  //   thumbnail: "/assets/images/segments/Others.svg",
  //   icon: OtherIcon,
  // },
  {
    id: "reference_solution",
    name: "Reference Solution",
    description: "Reference Solution",
    thumbnail: "/assets/images/segments/Others.svg",
    svg: "/assets/segments_icons/ece_others.svg",
    icon: OtherIcon,
  },
];


export const mpwSegmentSolution = [
  "fan_regional",
  "rail",
  "utility",
  "defence",
  "smart_city",
];
export const segmentOptions = {
  // full_control_nw: "Full control of network (FM/PM/CM)",
  // qui_classes: "Mission critical QCI classes",
  volte_emergencycall: "VoLTE and emergency call",
  // application_core: "Core functions with 3GPP standards",
};
export const additionalFeature = {
  fan_regional: segmentOptions,
  oil: segmentOptions,
  smart_city: segmentOptions,
  logistics: segmentOptions,
  rail: segmentOptions,
  manufacturing: segmentOptions,
  defence: segmentOptions,
  utility: segmentOptions,
  industrial: segmentOptions,
  mining: segmentOptions,
  energy: segmentOptions,
  port: segmentOptions,
  airport: segmentOptions,
  // others: segmentOptions,
  reference_solution: segmentOptions,

};

export const nonSCRMCaseTypes = [
  "internal_order",
  "demand_forecast"
];

export const caseCategory = {
  BIND: "Binding",
  BUDG: "Budgetary",
};

export const globalRequired = {
  caseName: true,
  sCRMID: null,
  account: true,
  sales_channel: true,
  endCustomer: true,
  country: true,
  market: true,
  shipping_country: true,
  currency: true,
  summary: false,
  co_owner: false,
  contract_duration: true,
  commercial_model: true
}

export const caseData = {
  new: [
    "sCRMID",
    "account",
    "caseName",
    "caseCategory",
    "public_funding_required",
    "sales_channel",
    "distributor",
    "resellers",
    "indirect_resellers",
    "endCustomer",
    "market",
    "country",
    "shipping_country",
    "currency",
    "summary",
    "co_owners"
  ],
  addition_to_existing_edge: [
    "sCRMID",
    "account",
    "caseName",
    "caseCategory",
    "contract_duration",
    "public_funding_required",
    "sales_channel",
    "distributor",
    "market",
    "resellers",
    "indirect_resellers",
    "endCustomer",
    "country",
    "shipping_country",
    "currency",
    "summary",
    "co_owners",
    "network_id",
    "commercial_model"
  ],
  non_commercial_network: [
    "sCRMID",
    "account",
    "caseName",
    "contract_duration",
    "public_funding_required",
    "sales_channel",
    "distributor",
    "resellers",
    "market",
    "endCustomer",
    "country",
    "shipping_country",
    "currency",
    "summary",
    "co_owners",
    "commercial_model"
  ],
  internal_order: [
    //  "sCRMID",
    "account",
    "caseName",
    "contract_duration",
    "sales_channel",
    "market",
    "endCustomer",
    "country",
    "shipping_country",
    "summary",
    "co_owners",
    "commercial_model"
  ],
  demand_forecast: [
    //  "sCRMID",
    "account",
    "caseName",
    "contract_duration",
    "sales_channel",
    "distributor",
    "market",
    "resellers",
    "endCustomer",
    "currency",
    "shipping_country",
    "summary",
    "co_owners",
    "country",
    "commercial_model"
  ],
  frame_agreement: [
    //"sCRMID",
    "account",
    "caseName",
    "contract_duration",
    "sales_channel",
    "distributor",
    "market",
    "resellers",
    "endCustomer",
    "shipping_country",
    "currency",
    "summary",
    "co_owners",
    "country",
    "commercial_model"
  ],
}; //r2

export const salesChannelLogic = {
  DIS: {
    visible: ["distributor", "indirect_resellers", "endCustomer"],
    hidden: ["resellers"],
    required:["distributor","endCustomer"]
  },
  RES: {
    visible: ["resellers", "endCustomer"],
    hidden: ["distributor", "indirect_resellers"],
    required:["resellers","endCustomer"]
  },
  DIR: {
    visible: ["endCustomer"],
    hidden: ["distributor", "indirect_resellers", "resellers"],
    required:["endCustomer"]
  },
};
export const navBarMenu = {
  HELPDESK: "https://help.dac.nokia.com/hc/en-us",
  DAC: "https://www.dac.nokia.com/",
  ODT: "https://use.dac.nokia.com/order-delivery-home/",
  OOT: "https://use.dac.nokia.com/offer-home/",
  TRAINING: "https://use.dac.nokia.com/offer-home/",
};
export const countryList = countryListData;
export const currencyList = currency;
export const apiTimeout = 60;
export const sCRMRegex = /(^\d{2})\.([\w]{2})\.(\d{6,})/;

